import { render, staticRenderFns } from "./ContentTab.vue?vue&type=template&id=20128323&scoped=true"
import script from "./ContentTab.vue?vue&type=script&lang=js"
export * from "./ContentTab.vue?vue&type=script&lang=js"
import style0 from "./ContentTab.vue?vue&type=style&index=0&id=20128323&prod&lang=css"
import style1 from "./ContentTab.vue?vue&type=style&index=1&id=20128323&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20128323",
  null
  
)

export default component.exports